module.exports = __webpack_public_path__ + "static/img/05-2-select-by-url.2995248.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lti-setup-guide/05-2-select-by-url.png
// module id = rhfd
// module chunks = 1